import { render } from "./PrintEdition.vue?vue&type=template&id=ae149290&ts=true"
import script from "./PrintEdition.vue?vue&type=script&lang=ts"
export * from "./PrintEdition.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__